export interface NewsletterEdition {
  id: string;
  number: number;
  title: string;
  period?: string;
  blurb: string;
  thumbnail: string;
  pdf: string;
}

export const newsletters: NewsletterEdition[] = [
  {
    id: "edition-4",
    number: 4,
    title: "Edition #4",
    period: "Apr — Jun 2025",
    blurb:
      "Mid-year reflections — graduations, new admissions, and what the monsoon brought to the Varanasi centre.",
    thumbnail:
      "https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/f287bfd4-08dd-4608-19a6-38aced582b00/publicMedium",
    pdf: "https://pub-76d6dce9ec88419c94fa8671a36dcc14.r2.dev/SE%20Apr-June%202025%20Newsletter.pdf",
  },
  {
    id: "edition-3",
    number: 3,
    title: "Edition #3",
    period: "Jan — Mar 2025",
    blurb:
      "First quarter of 2025 — the start of new courses, fresh student journeys, and a year of intent ahead.",
    thumbnail:
      "https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/e938f396-40ef-4f43-3952-f3a407690000/publicMedium",
    pdf: "https://pub-76d6dce9ec88419c94fa8671a36dcc14.r2.dev/SE%20Jan-Mar%202025%20Newsletter.pdf",
  },
  {
    id: "edition-2",
    number: 2,
    title: "Edition #2",
    period: "2024 reflection",
    blurb:
      "A new year, new graduations, new centres — and new milestones in the lives of our students.",
    thumbnail:
      "https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/e75a3f28-d142-42f3-b145-0654bad36e00/public",
    pdf: "https://pub-76d6dce9ec88419c94fa8671a36dcc14.r2.dev/SE%20Newsletter%20Edition%202%20compressed.pdf",
  },
  {
    id: "edition-1",
    number: 1,
    title: "Edition #1",
    period: "2023 reflection",
    blurb:
      "Our first reflection — the students, the work, and the community that built Sadafal Education over the past year.",
    thumbnail:
      "https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/264625c4-ccee-4175-ae92-bbd49d195b00/public",
    pdf: "https://pub-76d6dce9ec88419c94fa8671a36dcc14.r2.dev/SE%20Newsletter%20Edition%201%20compressed.pdf",
  },
];
